export const ALLOWED_TO_SCHEDULE = 'ALLOWED_TO_SCHEDULE' 
export const CONSULTATION_SCHEDULED = 'CONSULTATION_SCHEDULED'
export const MEDICAL_RETURN_AVAILABLE = 'MEDICAL_RETURN_AVAILABLE' 
export const MEDICAL_RETURN_SCHEDULED = 'MEDICAL_RETURN_SCHEDULED' 
export const SCHEDULE_CYCLE_END = 'SCHEDULE_CYCLE_END' 
export const INELIGIBLE = 'INELIGIBLE'